












































































































































































































































import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed,
  ref
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import FormHeader from '../../molecules/FormHeader.vue'
import CardRegistration from './RegisterCardInfor.vue'
import CompanyErrorDialog from '../../../views/CompanyInformation/CompanyErrorDialog.vue'
import DialogUpdateCompany from './DialogUpdateCompany.vue';
import customValidator from "@/lib/customValidator.ts"

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const companyInformationForm = ref(null)

    const getListPrefecture = companyRecruitment.getListPrefecture
    const getCompanyInfor = company.getCompanyInfor;
    onMounted(() => {
      getListPrefecture()
    });
    const dialogUpdateInfor = computed(() => displayui.dialogUpdateCompanyInfor);
    const openUpdateInfordialog = computed(() => displayui.openDialogUpdateComInfor)
    const closeUpdateInfordialog = computed(() => displayui.closeDialogUpdateComInfor)

    const openRegisterCardInfor = displayui.openDialogRegisterCard
    const companyInfor = computed(() => company.companyInformation);
    
    const companyInforList = computed(() => company.companyInformation.companyInforList);
    const registerCardInfor = async () => {
      await company.registerCardInfor();
      await displayui.closeDialogRegisterCard()
    }
    let compareTelephoneNumber = computed(() => company.companyInformation.compareTelephoneNumber) as any;
    const dialogUpdateInforCompany = () => {
      company.updateCompanyInfor();
      displayui.closeDialogUpdateComInfor()
    }
    const updateCompanyInfor = async() => {
      //@ts-ignore
      if(!companyInformationForm.value.validate()){
        return;
      }
      const telephone = computed(() => company.companyInformation.companyInforList.telephone_number).value.join('') as any
      if(compareTelephoneNumber.value !== telephone){
        displayui.openDialogUpdateComInfor();
      }else{
        execUpdateCompany();
      }
    }

    const execUpdateCompany = async() => {
      const updateCompany = await company.updateCompanyInfor() as any
       if(updateCompany.data){
        await displayui.openDialogCompanyError();
      }
    }

    const clearCompanyName = company.clearCompanyName
    onUnmounted(() => {
      company.clearCompanyInfor()
    })
    const registCardText = computed(() => company.registCardText)
    return {
      companyInfor,
      registerCardInfor,
      companyInforList,
      updateCompanyInfor,
      openRegisterCardInfor,
      dialogUpdateInfor,
      openUpdateInfordialog,
      closeUpdateInfordialog,
      dialogUpdateInforCompany,
      clearCompanyName,
      registCardText,
      execUpdateCompany,
      companyInformationForm,
      customValidator
    };
  },
  components: {
    FormHeader,
    CardRegistration,
    CompanyErrorDialog,
    DialogUpdateCompany,
  },
})
